/* file description */

import React, { useContext, useImperativeHandle, useState, useMemo, useEffect } from 'react';
import { Button, Modal, Space, Steps, message } from 'antd';
import type { SpComListType } from '../../index';
import { NEXT_CLICK } from './const';
import SpBusinessBtns from '@/components/sp-business-btns';
import { moduleRequest } from '@/components/sp-business-btns/effect/request';
import { postRecordList } from './../filterTree/service';
// import SpBusinessBtns from '@/components/sp-business-btns';

const { Step } = Steps;


const SpSteps: React.FC<SpComListType> = function SpSteps(props) {
  console.log('steps-props', props);
  const { metaConfig, values } = props;
  const dataMeta = metaConfig?.freeComponentsConfig?.dataMeta;

  const dataValue = values?.[metaConfig?.freeComponentsConfig?.dataModule]?.[metaConfig?.freeComponentsConfig?.dataField];

  const [stepCur, setStepCur] = useState(0);
  useEffect(() => {
    let index = 0;
    const metaList = dataMeta || [];
    for (let i = 0; i < metaList.length; i++) {
      const valuesList: any[] = metaList[i].value.split(',');
      if (valuesList.includes(dataValue)) {
        index = i;
        break;
      }
    }
    setStepCur(index);
  }, [props.values, dataMeta, dataValue]);


  const nextStep = async ({ open }: any) => {
    // if (stepCur === 1) {
    //   const res = await ismpCheckBindingMdm({
    //     recordId: values?.ltc_opportunity_basic_info?.ltc_opportunity_basic_info_id,
    //   });
    //   const result = res?.data?.result;
    //   if (result === 'false' || result === false) {
    //     const ltc_account_sales_team = values?.ltc_opportunity_basic_info?.ltc_account_sales_team_id;
    //     const salesRes = await postRecordList({
    //       app_id: 'tp',
    //       model_id: 'ltc_marketing_account_info',
    //       ltc_marketing_account_info_id: ltc_account_sales_team,
    //     });
    //     const salesData = salesRes?.data[0] || {};
    //     const initParams = JSON.stringify({
    //       md_custom_manage_organize: {
    //         county_district: salesData.account_area,
    //         nation: salesData.account_country,
    //         name: salesData.account_name,
    //         number: salesData.account_organize_id,
    //         industry: salesData.account_industry,
    //         street: salesData.full_address,
    //       },
    //     });
    //     open({
    //       actionType: 'modal',
    //       title: '客户经营组织创建',
    //       url: `/lcp/task/TASK20221219113116548673/create?initParams=${initParams}`,
    //     });
    //   } else if (result === 'true' || result === true) {
    //     await fetchStep(stepCur + 2);
    //   }
    //   return;
    // }
    if ((stepCur + 1) >= 3) {
      open({
        actionType: 'modal',
        title: '请选择',
        url: `/lcp/task/TASK20221209113646293162/edit/${metaConfig?.recordId}?SHOWTYPE=modal`,
        params: {
          ltc_opportunity_basic_info: {
            opportunit_stage: '4',
          },
        },
      });
      return;
    }
    await fetchStep(stepCur + 2);
  };
  const openCallBack = async () => {
    if (stepCur === 2) {
      await fetchStep(stepCur + 2);
    }
  };

  const fetchStep = async (num: number) => {
    const res = await moduleRequest(
      { ns: 'tp',
        module: metaConfig?.freeComponentsConfig?.dataModule,
        type: 'update',
        recordId: values?.ltc_opportunity_basic_info?.ltc_opportunity_basic_info_id,
        values: { ...values?.ltc_opportunity_basic_info, opportunit_stage: `${num}` },

      },
    );
    if (res.success) {
      message.success('推进成功');
      // setStepCur(num - 1);
      // TODO 数据刷新
      metaConfig?.reload();
    }
  };

  return (
    <>
      <Steps current={stepCur} style={{marginBottom: '10px'}}>
        {
          dataMeta.map((dm, index) => {
            return (
              <Step title={dm.label} key={index} />
            );
          })
        }
      </Steps>
      {
        (stepCur !== (dataMeta.length - 1) && dataMeta[stepCur]?.show) && <SpBusinessBtns
          openCallBack={openCallBack}
          utils={{ ...metaConfig?.utils, reload: metaConfig?.reload }}
          btnInfo={[{
            block: true,
            text: '下一步',
            cate: 'primary',
            position: '',
            freeJs: '',
          }]}
          btnsClick={(val) => nextStep(val)}
        />

      }

    </>
  );
};

export default SpSteps;

// <Button type="primary" block ghost style={{ marginTop: '30px' }} onClick={nextStep}>
//         //   下一步
//         // </Button>
